export default {
  calendarOptions: [],
  selectedCalendars: [],
}